import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../../context/Context";
import apiCall from "../../../services/apiCall";
import { toast } from "react-toastify";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { findCardLogo, hostName } from "../../../helpers/utils";
import ReferralCode from "../../common/ReferralCode";
import AddPayment from "../../admin-user-common/Billing/AddPayment";
import ButtonIcon from "../../common/ButtonIcon";
import AuthCardLayout from "../AuthCardLayout";
import default_card from "../../../assets/img/icons/creditcard-general.png"

const ApiplusPayment = () => {
  const { loginUserDetails } = useContext(AppContext);

  const isApiPlusExist =
    loginUserDetails?.is_partner == "1" &&
    loginUserDetails.user_type?.toLowerCase() !== "User".toLowerCase()
      ? sessionStorage.getItem("api_plus_plus")
        ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
        : false
      : false;
  const [isApiPlusOpen, setIsApiPlusOpen] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState({});
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [isPayment, setIsPayment] = useState(true);
  const [formValue, setFormValue] = useState({});
  const [defaultActiveKey, setDefaultActiveKey] = useState("credit");
  const [paymentCards, setPaymentCards] = useState([]);
  const [loginResponse, setLoginResponse] = useState({});
  const [isPaymentCardLoading, setIsPaymentCardLoading] = useState(false);
  const [referralCode, setReferralCode] = useState("");
  const [isApiPlusCalled, setIsApiPlusCalled] = useState(false);

  useEffect(() => {
    if (isApiPlusExist) {
      setIsPaymentCardLoading(true);
      var apiParam = { user_name: loginUserDetails.user_name };
      apiCall
        .servertrip("GET", "user_payment_cards", loginUserDetails, apiParam)
        .then(
          (res) => {
            setLoginResponse(res.data);
          },
          (error) => {}
        )
        .finally(() => {
          setIsPaymentCardLoading(false);
        });
    }
  }, []);

  useEffect(() => {
    if (isApiPlusExist) {
      setIsApiPlusOpen(true);
      if (loginResponse.cards) {
        if (loginResponse?.cards?.length > 0) {
          const userCards = loginResponse?.user_cards
            ? JSON.parse(loginResponse?.user_cards)
            : [];
          const cards = loginResponse?.cards.map((item) => {
            let foundCard = userCards.find(
              (userCard) =>
                userCard.customerPaymentProfileId == item.customer_payment_id
            );
            item["card_number"] =
              item.card_number || foundCard?.payment?.Item?.cardNumber;
            item["is_default"] = item.is_default == "yes" ? true : false;

            return item;
          });

          const defaultPayment = cards?.find((item) => item?.is_default);
          setPaymentCards(cards);
          setSelectedPayment(defaultPayment || {});
          setSelectedPaymentMethod("use_default_payment");
        } else {
          setSelectedPaymentMethod("add_new_payment");
          setPaymentCards([]);
        }
      } else {
        setSelectedPaymentMethod("add_new_payment");
        setPaymentCards([]);
      }
    }
  }, [loginResponse]);

  const HandleApiPlusApp = () => {
    let body = {
      username: loginUserDetails?.user_name,
    };

    if (isApiPlusExist) {
      body["redirect_url"] = isApiPlusExist["redirect_url"];
      body["callback_key"] = isApiPlusExist["callback_key"];
      body["request"] = isApiPlusExist["request"];
      body["referral_code_by"] = referralCode;
      body["project_id"] = isApiPlusExist["project_id"];
      body["source_project_id"] = isApiPlusExist["source_project_id"] ? isApiPlusExist["source_project_id"] : "";
      body["steps"] =
        selectedPaymentMethod == "add_new_payment"
          ? "add_new_payment"
          : "use_default_payment";

      if (selectedPaymentMethod == "add_new_payment") {
        if (defaultActiveKey == "credit") {
          const dateValue = formValue["credit_card_expiration_date"]?.split(
            "/"
          );

          if (selectedPaymentMethod == "add_new_payment") {
            const monthValue = dateValue[0];
            const yearValue = dateValue[1]?.slice(2);
            body["card_details"] = {};
            body["card_details"] = {
              type_of_payment: defaultActiveKey,
              card_number: formValue.credit_card_number,
              expiration_date: `${monthValue}/${yearValue}`,
              address: formValue.address,
              state: formValue.state,
              city: formValue.city,
              zip: formValue.zip,
              email_id: formValue.email_id?.toLowerCase(),
              first_name: formValue.first_name,
              last_name: formValue.last_name,
              cvv: formValue.credit_security_code,
              host: hostName(window.location.href),
            };
          }
        }

        if (defaultActiveKey == "ach") {
          body["card_details"] = {};
          body["card_details"] = {
            type_of_payment: defaultActiveKey,
            name_on_account: formValue.ach_name_on_account,
            bank_name: formValue.ach_bank_name,
            account_number: formValue.ach_account_number,
            routing_number: formValue.ach_routing_number,
            address: formValue.address,
            state: formValue.state,
            city: formValue.city,
            zip: formValue.zip,
            email_id: formValue.email_id?.toLowerCase(),
            first_name: formValue.first_name,
            last_name: formValue.last_name,
            host: hostName(window.location.href),
            account_type: "ach",
          };
        }
      } else {
        body["selected_payment_id"] = selectedPayment?.customer_payment_id;
        body["selected_profile_id"] = selectedPayment?.customer_profile_id;
      }
    }
    
    setIsApiPlusCalled(true);
    apiCall
      .servertrip(
        "POST",
        "api_plus_publish_app",
        loginUserDetails,
        undefined,
        body
      )
      .then((res) => {
        toast.success(res.data?.message);
        sessionStorage.removeItem("api_plus_plus");
        sessionStorage.removeItem("pastedLinkCount");
        setTimeout(() => {
          if (isApiPlusExist) {
            window.location.href = res.data?.url;
          }
        }, 2000);
      })
      .catch((error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
      })
      .finally(() => {
        setIsApiPlusCalled(false);
        setIsApiPlusOpen(false);
      });
  };

  return (
    <>
      <AuthCardLayout>
        <Row className="mb-2">
          <Col>
            <ReferralCode
              setReferralCode={setReferralCode}
              referralCode={referralCode}
            />
            <hr />
            <Row className="">
              <Col>
                <p
                  id="brand-text"
                  style={{
                    fontSize: "1em",
                  }}
                >
                  <b>Payment Methods</b>
                </p>
              </Col>
            </Row>

            {isPaymentCardLoading ? (
              <>
                <p className="">Loading your saved payment methods...</p>
              </>
            ) : (
              <>
                {paymentCards.length > 0  && (
                  <>
                    {paymentCards.map((item, itemIndex) => {
                      return (
                        <>
                          <FormGroup check className="mb-1">
                            <Input
                              name="use_default_payment"
                              type="radio"
                              value={item?.customer_payment_id}
                              defaultChecked={
                                item?.customer_payment_id ==
                                selectedPayment?.customer_payment_id
                              }
                              onChange={(e) => {
                                setSelectedPayment(item);
                                setSelectedPaymentMethod(e.target.value);
                              }}
                              className="mr-2"
                            />

                            <img
                              key={item?.card_logo + itemIndex}
                              src={
                                findCardLogo(item?.card_logo)?.logoUrl
                                  ? findCardLogo(item?.card_logo)?.logoUrl
                                  : default_card
                              }
                              alt={item?.card_logo || `${itemIndex}_card_logo`}
                              style={{ height: "1.5em" }}
                            />

                            <Label className="ml-2" check>
                              {selectedPaymentMethod ==
                              item?.customer_payment_id ? (
                                <>
                                  <b>
                                    {item?.card_logo}{" "}
                                    {item?.card_number
                                      ? `: ${item?.card_number}`
                                      : ""}
                                    {/* {maskNumber(item?.customer_payment_id)} */}
                                  </b>
                                </>
                              ) : (
                                <>
                                  {item?.card_logo}{" "}
                                  {item?.card_number
                                    ? `: ${item?.card_number}`
                                    : ""}
                                  {/* {maskNumber(item?.customer_payment_id)} */}
                                </>
                              )}
                            </Label>
                          </FormGroup>
                        </>
                      );
                    })}
                  </>
                )}
              </>
            )}
            
                {/* <hr /> */}
            <FormGroup check>
                  <Input
                    name="use_default_payment"
                    type="radio"
                    value={"add_new_payment"}
                    onChange={(e) => {
                      setSelectedPayment({});
                      setSelectedPaymentMethod(e.target.value);
                    }}
                    defaultChecked={selectedPaymentMethod == "add_new_payment"}
                  />
                  <Label check>
                    {selectedPaymentMethod == "add_new_payment" ? (
                      <b>Add New Payment</b>
                    ) : (
                      "Add New Payment"
                    )}
                  </Label>
            </FormGroup>              
          </Col>
        </Row>

        {(selectedPaymentMethod == "add_new_payment") &
        !isPaymentCardLoading ? (
          <>
            <AddPayment
              setFormValue={setFormValue}
              formValue={formValue}
              handlePaymentFormSubmit={HandleApiPlusApp}
              setDefaultActiveKey={setDefaultActiveKey}
              defaultActiveKey={defaultActiveKey}
              setIsActive={setIsPayment}
              showAddButton={true}
              showCancelButton={false}
              addButtonText={"Register & Publish Your App"}
              isApiCalled={isApiPlusCalled}
              showVerificationNotice={false}
              customButton={"btn-success"}
              isReferral={true}
              submitButtonCustomClass={"sai_button"}
            />
          </>
        ) : (
          <></>
        )}

        {selectedPaymentMethod !== "add_new_payment" &&
        !isPaymentCardLoading ? (
          <>
            <Row className="">
              <Col className="d-flex justify-content-end align-items-end">
                <ButtonIcon
                  // color="success"
                  size="sm"
                  icon="Sync"
                  className={`ml-1 mt-lg-0 mb-2 ${isApiPlusExist ? 'sai_button' :'text-light'}`}
                  iconClassName="fs--2"
                  onClick={HandleApiPlusApp}
                  disabled={isApiPlusCalled}
                >
                  Register & Publish Your App
                </ButtonIcon>
              </Col>
            </Row>
          </>
        ) : (
          <></>
        )}
      </AuthCardLayout>
    </>
  );
};

export default ApiplusPayment;
